import { request } from '../../../../../../utils'
import { getCurrentLocale } from '../../../../../../utils/getCurrentLocale'

export interface ImportContactsResult {
  created: number
  updated: number
  unmapped: string[]
}

export const importContactsCsv = async (organizationId: string, file: File): Promise<ImportContactsResult> => {
  const locale = getCurrentLocale()
  const { data } = await request(
    `/v2/organizations/${organizationId}/contacts`,
    {
      method: 'PATCH',
      headers: {
        'accept-language': locale,
        'X-Filename': encodeURI(file.name),
        'X-File-Size': String(file.size),
      },
      body: file,
    },
    { withAuth: true, skipContentType: true, returnRawResponse: false },
  )
  return data
}
